import type { UserType } from '@/types/AuthState';

export function resolveCanCreateSix(userType: UserType | null): boolean {
  return userType === 'Internal';
}
